"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DoubleBag = exports.Bag = void 0;
/**
 * Map which acts as a counter for the number of times an item is added.
 */
class Bag extends Map {
    add(key, count = 1) {
        this.set(key, this.count(key) + count);
    }
    count(key) {
        return this.get(key) ?? 0;
    }
}
exports.Bag = Bag;
/**
 * Map which acts as a '2d' counter for the number of times an item pair is added.
 */
class DoubleBag extends Map {
    add(outer, inner, count = 1) {
        let bag = this.get(outer);
        if (!bag) {
            bag = new Bag();
            this.set(outer, bag);
        }
        bag.add(inner, count);
    }
    count(outer, inner) {
        return this.get(outer)?.count(inner) ?? 0;
    }
}
exports.DoubleBag = DoubleBag;
